"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFooter = exports.ModalBody = exports.ModalHeader = exports.ModalTitle = void 0;
var React = __importStar(require("react"));
var ReactDOM = __importStar(require("react-dom"));
var classnames_1 = __importDefault(require("classnames"));
var eventUtils_1 = require("../common/eventUtils");
var prefix = 'tk-dialog';
var buildClass = function (classStr) { return prefix + "__" + classStr; };
exports.ModalTitle = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    return React.createElement("div", __assign({ className: classnames_1.default(buildClass('title'), className) }, rest), children);
};
exports.ModalHeader = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    return React.createElement("div", __assign({ className: classnames_1.default(buildClass('header'), className) }, rest),
        " ",
        children);
};
exports.ModalBody = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    return React.createElement("div", __assign({ className: classnames_1.default(buildClass('body'), className) }, rest), children);
};
exports.ModalFooter = function (_a) {
    var className = _a.className, children = _a.children, rest = __rest(_a, ["className", "children"]);
    return React.createElement("div", __assign({ className: classnames_1.default(buildClass('footer'), className) }, rest),
        " ",
        children);
};
var Modal = function (_a) {
    var _b;
    var size = _a.size, className = _a.className, children = _a.children, closeButton = _a.closeButton, onClose = _a.onClose, parentNode = _a.parentNode, show = _a.show, rest = __rest(_a, ["size", "className", "children", "closeButton", "onClose", "parentNode", "show"]);
    var containerClasses = classnames_1.default(className, prefix + "-backdrop");
    var sizeClasses = classnames_1.default(prefix, (_b = {}, _b[prefix + "--" + size] = size, _b));
    var handleContentClick = function (event) { return event.stopPropagation(); };
    var onMouseDown = function (event) { return event.stopPropagation(); };
    var handleKeyUp = function (event) {
        if (onClose && event.key === eventUtils_1.Keys.ESC) {
            event.stopPropagation();
            onClose();
        }
    };
    var domResult = (React.createElement("div", __assign({ onMouseDown: onMouseDown }, rest, { className: containerClasses, onClick: onClose, onKeyUp: handleKeyUp, tabIndex: -1 }),
        React.createElement("div", { role: "dialog", className: sizeClasses, onClick: handleContentClick },
            closeButton && (React.createElement("button", { type: "button", "aria-label": "close", className: buildClass('close'), onClick: onClose })),
            children)));
    return show
        ? parentNode
            ? ReactDOM.createPortal(domResult, parentNode)
            : domResult
        : null;
};
exports.default = Modal;
